import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  increment,
  decrement,
} from "../data/redux/features/counter/counterSlice";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { value } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  
  if (token == null || token == "undefined") {
    navigate("/login");
  }
  return (
    <div>
      <div className="text-dark">
        Dashboard
        <div>
          <h1>Redux Counter: {value}</h1>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => dispatch(increment())}
          >
            +
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => dispatch(decrement())}
          >
            -
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
